<template>
  <div class="primary-container">
    <Forbidden v-if="getUserRole[getUserRole.length - 1].role_id == 0" routerPath="notLogin" />
    <Forbidden
      v-else-if="
    getUserRole[0].role_id != userRole.STUDENT_CANDIDATE || 
    !getHasProgramRegistered
    "
      routerPath="incorrectRole"
    />
    <div class="primary-container" v-else-if=" getAnnouncementAvailable">
      <AnnouncementSuccess v-if="getIsPassed" />
      <AnnouncementFailed v-else />
    </div>
    <div v-else class="primary-container vector-background col center">
      <ErrorMaintenance :img="img" :title="title" :msg="msg" :goto="goto" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Forbidden from "@/views/Forbidden";
import ErrorMaintenance from "@/components/ErrorPage";
import AnnouncementFailed from "@/views/AnnouncementFailed";
import AnnouncementSuccess from "@/views/AnnouncementSuccess";
import { UserRole, TermStatus } from "@/services/StatusCode";

export default {
  name: "Announcement",
  components: {
    ErrorMaintenance,
    Forbidden,
    AnnouncementFailed,
    AnnouncementSuccess
  },
  computed: {
    ...mapGetters({
      getRegisEvaluation: "getRegisEvaluation",
      getAccessToken: "getAccessToken",
      getAnnouncementAvailable: "getAnnouncementAvailable",
      getIsPassed: "getIsPassed",
      getUserRole: "getUserRole",
      getHasProgramRegistered: "getHasProgramRegistered"
    })
  },
  data() {
    return {
      img: require("@/assets/img/404-not-found.png"),
      title: "Tidak ada pengumuman",
      msg: "Silahkan menunggu beberapa hari lagi !",
      goto: [
        {
          link: "/",
          str: "Back to home"
        }
      ],
      userRole: UserRole,
      termStatus: TermStatus
    };
  }
};
</script>

<style lang="scss" scoped>
.primary-container {
  min-height: inherit;
}
</style>
